import { inject } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { AccountService } from "app/services/account.service";
import { ProfileStore } from "app/store/profile.store";
import { take, tap } from "rxjs";

export const userProfileResolver: ResolveFn<any> = () => {
    const store = inject(ProfileStore);
    const service = inject(AccountService);

    return service.getMyAccountDetails().pipe(
        tap((response) => store.loadProfile(response)),
        take(1)
    )
}